"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightKeyTerms = exports.KeyTermsProvider = void 0;
const React = __importStar(require("react"));
const react_highlight_words_1 = __importDefault(require("react-highlight-words"));
const terms_json_1 = __importDefault(require("./terms.json"));
const KeyTerm_1 = require("./KeyTerm");
const termMap = new Map(Object.entries(terms_json_1.default).map(([key, value]) => [key.toLowerCase(), value]));
const KeyTermsContext = React.createContext(null);
const KeyTermsProvider = ({ children, threshold = 1 }) => {
    return (React.createElement(KeyTermsContext.Provider, { value: {
            keyTerms: new Map(),
            threshold,
        } }, children));
};
exports.KeyTermsProvider = KeyTermsProvider;
const HighlightKeyTerms = ({ children, maxHighlightExtension = 3 }) => {
    const context = React.useContext(KeyTermsContext);
    return (React.createElement(React.Fragment, null, React.Children.map(children, (child) => {
        if (typeof child !== "string") {
            return child;
        }
        return (React.createElement(react_highlight_words_1.default, { searchWords: Object.keys(terms_json_1.default), textToHighlight: child, findChunks: ({ searchWords, textToHighlight }) => {
                const chunks = [];
                const normalizedTextToHighlight = textToHighlight.toLowerCase();
                for (const word of searchWords) {
                    if (typeof word !== "string" || !word.length) {
                        continue;
                    }
                    const index = normalizedTextToHighlight.indexOf(word.toLowerCase());
                    if (index === -1) {
                        continue;
                    }
                    const term = termMap.get(word.toLowerCase());
                    if (term &&
                        "surroundingContextsToAvoid" in term.frontmatter &&
                        Array.isArray(term.frontmatter.surroundingContextsToAvoid)) {
                        // Escape characters for use in regexp
                        const escapedContexts = term.frontmatter.surroundingContextsToAvoid.map((c) => c.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&"));
                        if (new RegExp(escapedContexts.join("|"), "i").test(normalizedTextToHighlight)) {
                            continue;
                        }
                    }
                    let endIndex = index + word.length;
                    for (let i = 0; i < maxHighlightExtension; i++) {
                        const isAlpha = /[a-z]/.test(normalizedTextToHighlight[endIndex]);
                        if (isAlpha) {
                            endIndex++;
                        }
                        else {
                            break;
                        }
                    }
                    // If we have iterated and the term still has a letter next, reset the endIndex
                    // else the hightlight would cover _queryabl_e where only the e is unhighlighted
                    if (/[a-z]/.test(normalizedTextToHighlight[endIndex])) {
                        endIndex = index + word.length;
                    }
                    chunks.push({
                        start: index,
                        end: endIndex,
                    });
                }
                return chunks;
            }, highlightTag: ({ children }) => {
                const searchTerm = children.toLowerCase();
                let term = termMap.get(searchTerm);
                let actualTerm = searchTerm;
                let backtrack = 0;
                while (!term && backtrack <= maxHighlightExtension) {
                    // Try to find a term while slicing the backtrack to support plurals
                    // and other word variations
                    // e.g. documents -> document !Match
                    // but with the maximum extension in mind
                    // e.g. documentation -> documentatio -> documentati !No Match, max extension reached
                    actualTerm = searchTerm.slice(0, -backtrack);
                    term = termMap.get(actualTerm);
                    backtrack++;
                }
                if (!term) {
                    console.warn(`No definition found for ${children}`);
                    return children;
                }
                if (context) {
                    const keyTerm = context.keyTerms.get(children);
                    if (keyTerm && keyTerm >= context.threshold) {
                        return children;
                    }
                    context.keyTerms.set(children, keyTerm ? keyTerm + 1 : 1);
                }
                return React.createElement(KeyTerm_1.KeyTerm, { term: children, definition: term.definition });
            } }));
    })));
};
exports.HighlightKeyTerms = HighlightKeyTerms;
//# sourceMappingURL=HighlightKeyTerms.js.map